import {
  DrawerMenuItemLink,
  DrawerMenuItemSubmenu,
  DrawerMenuItemType,
} from "@/lib/main";
import DrawerMenuItemAction from "./DrawerMenuItemAction";

type Props = {
  drawerMenuItem: DrawerMenuItemType;
  isDrawerOpen: boolean;
  isHashLinks?: boolean;
  setIsDrawerOpen: (isDrawerOpen: boolean) => void;
  shoppingCartCount?: number;
  openSubmenuId?: string | null;
  setOpenSubmenuId?: (id: string | null) => void;
};

export default function DrawerMenuItem({
  drawerMenuItem,
  isDrawerOpen,
  isHashLinks,
  setIsDrawerOpen,
  shoppingCartCount,
  openSubmenuId,
  setOpenSubmenuId,
}: Props) {
  const { kind } = drawerMenuItem;

  return (
    <>
      {kind === "action" ? (
        <DrawerMenuItemAction
          drawerMenuItem={drawerMenuItem}
          setIsDrawerOpen={setIsDrawerOpen}
          shoppingCartCount={shoppingCartCount}
        />
      ) : kind === "link" ? (
        <DrawerMenuItemLink
          drawerMenuItem={drawerMenuItem}
          isHashLinks={isHashLinks}
          setIsDrawerOpen={setIsDrawerOpen}
          shoppingCartCount={shoppingCartCount}
        />
      ) : kind === "submenu" ? (
        <DrawerMenuItemSubmenu
          drawerMenuItem={drawerMenuItem}
          isDrawerOpen={isDrawerOpen}
          isHashLinks={isHashLinks}
          setIsDrawerOpen={setIsDrawerOpen}
          openSubmenuId={openSubmenuId}
          setOpenSubmenuId={setOpenSubmenuId}
        />
      ) : null}
    </>
  );
}
